import React from "react";

import { BtnChiTietKiemKho } from "./ChucNang/ChiTietKiemKho/BtnChiTietKiemKho";
import { BtnInBienBanKiemKho } from "./ChucNang/InBienBanKiemKho/BtnInBienBanKiemKho";

export const ContentTable = ({
  listDsKiemKhoFull,
  quyenXemChiTiet,
  quyenInChiTiet,
  startIndex = 0,
}) => {
  return listDsKiemKhoFull.map((item, index) => (
    <div className="custom-table-row" key={"item" + (startIndex + index)}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">{startIndex + index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Thời gian</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.NgayKiem}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
        <span className="mobile-column-name">Mã</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.Code}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-40 flex-basis-40-sm">
        <span className="mobile-column-name">Người kiểm</span>
        <div className="center-wrapper color7">
          <p className="text-left">{item.NguoiKiem}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {quyenXemChiTiet && <BtnChiTietKiemKho item={item} />}

            {quyenInChiTiet && <BtnInBienBanKiemKho Id={item.Id} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
